import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ContactDetailItemHeaderProps as Props } from './types';

export const ContactDetailItemHeader = memo(
  ({ className, title, count }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ContactDetailItemHeader', className)}
        sx={SX.root}
      >
        <Typography variant="body3" fontWeight="500" color="grey.800">
          {count ? `${title} (${count})` : title}
        </Typography>
      </Styled.Wrapper>
    );
  }
);

ContactDetailItemHeader.displayName = 'ContactDetailItemHeader';
